import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/billing";

export const getBillingGroupsByUser = async (userPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-user/${userPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingGroupsByAgreement = async (agreementPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-agreement/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingGroupsByLicense = async (
  licensePublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-license/${licensePublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getIndexAdjustmentsByAgreement = async (
  agreementPublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/IndexAdjustment/get-index-adjustments-by-agreement/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingHistoryByAgreement = async (
  agreementPublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingHistory/get-billing-history-by-agreement-id/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch history"
    );
  }
};

export const getBillingHistoryDetailsByBillingHistory = async (
  billingHistoryPublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingHistory/get-billing-history-details-by-billing-history-id/${billingHistoryPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );    

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch history"
    );
  }
};
